import { render, staticRenderFns } from "./AccountSidebar.vue?vue&type=template&id=ed314100"
import script from "./AccountSidebar.vue?vue&type=script&lang=ts"
export * from "./AccountSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AccountSidebar.vue?vue&type=style&index=0&id=ed314100&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports